import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { ViewStyle } from 'react-native';
import { StyledProps } from 'styled-components';
import styled from 'styled-components/native';

interface Props {
  checked?: boolean;
  style?: StyledProps<ViewStyle>;
  checkedStyle?: StyledProps<ViewStyle>;
}

const CheckBoxCircle = ({ checked, style, checkedStyle }: Props) => (
  <CheckBox checked={checked} style={checked ? checkedStyle : style}>
    <FontAwesomeIcon
      icon={checked ? 'check' : 'plus'}
      color={checked ? 'white' : '#929999'}
      size={checked ? 12 : 14}
    />
  </CheckBox>
);

const CheckBox = styled.View<{ checked?: boolean }>`
  height: 23px;
  width: 23px;

  align-items: center;
  justify-content: center;

  border-radius: 50px;

  border-color: #929999;
  background-color: ${({ checked }) => (checked ? '#535AF1' : 'white')};
  border-width: ${({ checked }) => (checked ? '0px' : '2px')};
`;

export default CheckBoxCircle;
